import(/* webpackMode: "eager" */ "/codebuild/output/src692948387/src/medimo-dev/front/apps/web/app/loading.tsx");
